import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const PrequalNotStarted = () => {
  const { t } = useTranslation()
  return <Typography variant="body1">{t('viewCreditApplication.prequalNotStarted')}</Typography>
}

export default PrequalNotStarted
